<div class="table-responsive" [innerHTML]="block.tabella | safeHtml"></div>